<div class="col-md-10">
  <div class="row">
    <div class="col-md-7">
      <form [formGroup]="form" (keydown.enter)="createReport()">
        <app-common-search-view [form]="form" header="Analys medlemsflöde" (createReport)="createReport()" [showSpinner]="showSpinner" (clearReportView)="clearReport()" [multiple]=false></app-common-search-view>
      </form>
    </div>
    <br><br>
    <div *ngIf="result" class="col-md-4" style="margin-top:60px;">
      <p-menubar [model]="items">
      </p-menubar>
      <div *ngFor="let r of result">
        <div class="row">
          <div class="col-md-12"><b>{{r?.result?.year}} - <span *ngIf="r?.result.type">{{r?.result?.type}}</span><span *ngIf="r?.result.shortName">{{r?.result.shortName}} {{r?.result.name}}</span></b></div>
        </div>
        <div class="row">
          <div class="col-md-10">Antal vid årets början: <b>{{r?.result?.membersAtStartOfYear}}</b></div>
        </div>
        <div class="row">
          <div class="col-md-2"><i>Tillkommande</i></div>
        </div>
        <table>
          <tr *ngFor="let i of r?.result?.incoming">
            <td>{{i.institution}}</td>
            <td>{{i.count}}</td>
            <td>{{i.description}}</td>
          </tr>
        </table>
        <div class="row">
          <div class="col-md-2"><i>Avgående</i></div>
        </div>
        <table>
          <tr *ngFor="let o of r?.result?.outgoing">
            <td>{{o.institution}}</td>
            <td>{{o.count}}</td>
            <td>{{o.description}}</td>
          </tr>
        </table>
        <div class="row">
          <div class="col-md-10">Antal vid årets slut:<b> {{r?.result?.membersAtEndOfYear}}</b></div>
        </div>
        <br><br>
      </div>
    </div>
  </div>
</div>